module.exports = __webpack_public_path__ + "img/logo-shopify.ee306d89.svg";